import React from 'react';
import styles from './SideColumn.module.css';
// Timeline component removed; timeline functionality deprecated
import FiltersPanel from './FiltersPanel';
import * as dashboardApi from '../../api/dashboardApi';

interface Props {
  trendingTopics: string[];
  // timeline removed
  // new props
  activeFeedTab: string;
  // filters props forwarded when needed
  token?: string | null;
  selectedCountry?: string;
  setSelectedCountry?: (c: string) => void;
  jurisdictions?: dashboardApi.Jurisdiction[];
  selectedJurisdiction?: string;
  setSelectedJurisdiction?: (j: string) => void;
  availableJurisdictionTypes?: string[];
  jurisdictionFilters?: Record<string, boolean>;
  setJurisdictionFilters?: (v: Record<string, boolean>) => void;
  availableRegulationTypes?: string[];
  policyTypeFilters?: Record<string, boolean>;
  setPolicyTypeFilters?: (v: Record<string, boolean>) => void;
  dateFilterType?: string;
  // handlers can be state setters or callbacks from parent — accept any to match parent signatures
  setDateFilterType?: any;
  selectedTimeRange?: string;
  handleTimeRangeChange?: any;
  showCustomDatePicker?: boolean;
  customStartDate?: string;
  customEndDate?: string;
  setCustomStartDate?: (s: string) => void;
  setCustomEndDate?: (s: string) => void;
  isLoadingJurisdictions?: boolean;
  // override to force showing filters regardless of active tab
  showFiltersOverride?: boolean;
  onClearFilters?: () => void;
  hasActiveFilters?: boolean;
}

const SideColumn: React.FC<Props> = (props) => {
  const { activeFeedTab } = props;

  // Only show filters for these feed tabs
  const filtersAllowed = ['alerts', 'feed', 'all'];
  const shouldShowFilters = filtersAllowed.includes(activeFeedTab) || !!props.showFiltersOverride;

  return (
    <aside className={styles.sideColumn}>
      {shouldShowFilters ? (
        <div className={styles.sideCard}>
          <div className={styles.sideCardHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Filters</span>
            <div>
              <button type="button" onClick={props.onClearFilters as any} disabled={!props.hasActiveFilters} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid var(--ds-info-bg)', background: props.hasActiveFilters ? 'var(--ds-surface)' : 'var(--ds-surface-2)', cursor: props.hasActiveFilters ? 'pointer' : 'not-allowed' }}>Clear</button>
            </div>
          </div>
          <FiltersPanel
            token={props.token}
            selectedCountry={props.selectedCountry || ''}
            setSelectedCountry={props.setSelectedCountry as any}
            jurisdictions={props.jurisdictions || []}
            selectedJurisdiction={props.selectedJurisdiction || 'All'}
            setSelectedJurisdiction={props.setSelectedJurisdiction as any}
            availableJurisdictionTypes={props.availableJurisdictionTypes || []}
            jurisdictionFilters={props.jurisdictionFilters || {}}
            setJurisdictionFilters={props.setJurisdictionFilters as any}
            availableRegulationTypes={props.availableRegulationTypes || []}
            policyTypeFilters={props.policyTypeFilters || {}}
            setPolicyTypeFilters={props.setPolicyTypeFilters as any}
            dateFilterType={(props.dateFilterType as any) || 'last_action_date'}
            setDateFilterType={props.setDateFilterType as any}
            selectedTimeRange={(props.selectedTimeRange as any) || 'All'}
            handleTimeRangeChange={props.handleTimeRangeChange as any}
            showCustomDatePicker={!!props.showCustomDatePicker}
            customStartDate={props.customStartDate || ''}
            customEndDate={props.customEndDate || ''}
            setCustomStartDate={props.setCustomStartDate as any}
            setCustomEndDate={props.setCustomEndDate as any}
            isLoadingJurisdictions={props.isLoadingJurisdictions}
            showDateFilters={activeFeedTab === 'alerts' ? false : activeFeedTab !== 'feed'}
            showRecentNote={activeFeedTab === 'feed'}
            showActiveAlertsNote={activeFeedTab === 'alerts'}
          />
        </div>
      ) : null}
    </aside>
  );
};

export default SideColumn;
